import React, { useState } from 'react';
import { Container, Modal, Button } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import '../../styles/footer.css';
import { BsPhone } from 'react-icons/bs';
import { MdOutlineMailOutline } from 'react-icons/md';
import GoogleMapReact from 'google-map-react';

const Marker = ({ text }) => (
  <div style={{ color: 'black', fontWeight: 'bold' }}> &#x25cf; {text}</div>
);

function Footer() {
  const [showTerms, setShowTerms] = useState(false);
  const [showPartner, setShowPartner] = useState(false);

  const defaultProps = {
    center: {
      lat: 35.46948,
      lng: -97.50636461496995,
    },
    zoom: 11,
  };

  const year = new Date().getFullYear();

  return (
    <Container
      fluid
      className="w-100 footer"
      style={{ '--bs-gutter-x': '0rem' }}
    >
      <div className="info-div">
        <div className="info-child">
          <h4>Datagenetx</h4>

          <div>
            322 N.E 2nd Street <br />
            2nd Floor <br />
            Oklahoma City, OK 73104
          </div>
        </div>
        <div className="info-child">
          <h4>Contact Us</h4>

          <div className="contact-us">
            <div className="footer-icon">
              <BsPhone />
            </div>
            <a href="tel:4054559053">(405) 455-9053</a>
          </div>

          <div className="contact-us">
            <div className="footer-icon">
              <MdOutlineMailOutline />
            </div>
            <a href="mailto:info@datagenetx.com">info@datagenetx.com</a>
          </div>
        </div>
        <div className="info-child" style={{ width: '250px', height: '250px' }}>
          <GoogleMapReact
            bootstrapURLKeys={{ key: process.env.REACT_APP_GOOGLE_MAPS_KEY }}
            defaultCenter={defaultProps.center}
            defaultZoom={defaultProps.zoom}
          >
            <Marker
              lat={35.46947850194029}
              lng={-97.50636461496995}
              text="Datagenetx"
            />
          </GoogleMapReact>
        </div>

        <div className="footerLinks d-flex flex-wrap justify-content-center gap-3 w-100">
        <button className="footer-link-btn" onClick={() => setShowTerms(true)}>Terms &amp; Conditions</button>
        <a href="https://qualfon.com/privacy-policy/" target="_blank" rel="noreferrer">Privacy Policy</a>
        <a href="https://qualfon.com/privacy-policy/ca-privacy-notice/" target="_blank" rel="noreferrer">CA Privacy Notice</a>
        <a href="https://datagenetx.com/ccpa-form" target="_blank" rel="noreferrer" style={{ whiteSpace: 'nowrap' }}>
          Your Privacy Choices
        </a>
        <button className="footer-link-btn" onClick={() => setShowPartner(true)}>Partner/Affiliates</button>
        </div>
      </div>

      <div className="footerBottom d-flex text-center justify-content-center">
        &copy; {year} &nbsp;{' '}
        <a
          style={{ textDecoration: 'underline' }}
          href="https://www.leadvisionmedia.com/"
        >
          LeadVision Media LLC.
        </a>
      </div>

      <Modal show={showTerms} onHide={() => setShowTerms(false)} centered size="lg" scrollable>
        <Modal.Header closeButton>
          <Modal.Title>Terms &amp; Conditions</Modal.Title>
        </Modal.Header>
        <Modal.Body style={{ fontSize: '0.85rem' }}>
          <strong style={{ display: 'block' }}>Terms</strong>
          <span style={{ display: 'block', marginBottom: '0.5rem' }}>Updated Jan 11th, 2026</span>
          <p>By accessing the Datagenetx web site or other domains under our control, you are agreeing to be bound by these web site Terms and Conditions of Use, all applicable laws and regulations, and agree that you are responsible for compliance with any applicable local laws. If you do not agree with any of these terms, you are prohibited from using or accessing this site. The materials contained in this web site are protected by applicable copyright and trademark law.</p>

          <strong style={{ display: 'block' }}>Site Security Rules</strong>
          <p>You are prohibited from violating or attempting to violate the security of Datagenetx, including, without limitation, (a) intercepting or accessing data not intended for such user or logging into a server or account which the user is not authorized to access, (b) attempting to probe, scan or test the vulnerability of a system or network or to breach security or authentication measures without prior express written authorization, (c) attempting to interfere with service to any user, host or network, including, without limitation, via means of submitting a virus to any Datagenetx, overloading, "flooding", "denial of service attacking", "spamming", "mailbombing" or "crashing", (d) sending unsolicited e-mail, including promotions and/or advertising of products or services, or (e) forging any TCP/IP packet header or any part of the header information in any e-mail or newsgroup posting. Violations of system or network security may result in civil or criminal liability.</p>

          <strong style={{ display: 'block' }}>Use License</strong>
          <p>Permission is granted to temporarily download one copy of the materials (information or software) on Datagenetx web site for personal, non-commercial transitory viewing only. This is the grant of a license, not a transfer of title, and under this license you may not: modify or copy the materials; use the materials for any commercial purpose, or for any public display (commercial or non-commercial); attempt to decompile or reverse engineer any software contained on Datagenetx web site; remove any copyright or other proprietary notations from the materials; or transfer the materials to another person or "mirror" the materials on any other server. This license shall automatically terminate if you violate any of these restrictions and may be terminated by Datagenetx at any time.</p>

          <strong style={{ display: 'block' }}>Disclaimer</strong>
          <p>The materials on Datagenetx's web site are provided "as is". Datagenetx makes no warranties, expressed or implied, and hereby disclaims and negates all other warranties, including without limitation, implied warranties or conditions of merchantability, fitness for a particular purpose, or non-infringement of intellectual property or other violation of rights. Further, Datagenetx does not warrant or make any representations concerning the accuracy, likely results, or reliability of the use of the materials on its Internet web site or otherwise relating to such materials or on any sites linked to this site.</p>

          <strong style={{ display: 'block' }}>Limitations</strong>
          <p>In no event shall Datagenetx or its suppliers be liable for any damages (including, without limitation, damages for loss of data or profit, or due to business interruption) arising out of the use or inability to use the materials on Datagenetx's Internet site, even if Datagenetx or a Datagenetx authorized representative has been notified orally or in writing of the possibility of such damage. WE WILL NOT BE LIABLE FOR ANY LOSS OR DAMAGE CAUSED BY A DISTRIBUTED DENIAL-OF-SERVICE ATTACK, VIRUSES OR OTHER TECHNOLOGICALLY HARMFUL MATERIAL THAT MAY INFECT YOUR COMPUTER EQUIPMENT, COMPUTER PROGRAMS, DATA OR OTHER PROPRIETARY MATERIAL DUE TO YOUR USE OF THE WEBSITE. YOUR USE OF THE WEBSITE, ITS CONTENT AND ANY SERVICES OR ITEMS OBTAINED THROUGH THE WEBSITE IS AT YOUR OWN RISK.</p>

          <strong style={{ display: 'block' }}>Limitation on Liability</strong>
          <p>IN NO EVENT WILL THE COMPANY, ITS AFFILIATES OR THEIR LICENSORS, SERVICE PROVIDERS, EMPLOYEES, AGENTS, OFFICERS OR DIRECTORS BE LIABLE FOR DAMAGES OF ANY KIND, UNDER ANY LEGAL THEORY, ARISING OUT OF OR IN CONNECTION WITH YOUR USE, OR INABILITY TO USE, THE WEBSITE, ANY WEBSITES LINKED TO IT, ANY CONTENT ON THE WEBSITE OR SUCH OTHER WEBSITES OR ANY SERVICES OR ITEMS OBTAINED THROUGH THE WEBSITE OR SUCH OTHER WEBSITES, INCLUDING ANY DIRECT, INDIRECT, SPECIAL, INCIDENTAL, CONSEQUENTIAL OR PUNITIVE DAMAGES, INCLUDING BUT NOT LIMITED TO, PERSONAL INJURY, PAIN AND SUFFERING, EMOTIONAL DISTRESS, LOSS OF REVENUE, LOSS OF PROFITS, LOSS OF BUSINESS OR ANTICIPATED SAVINGS, LOSS OF USE, LOSS OF GOODWILL, LOSS OF DATA.</p>

          <strong style={{ display: 'block' }}>Indemnification</strong>
          <p>You agree to defend, indemnify and hold harmless the Company, its affiliates, licensors and service providers, and its and their respective officers, directors, employees, contractors, agents, licensors, suppliers, successors and assigns from and against any claims, liabilities, damages, judgments, awards, losses, costs, expenses or fees (including reasonable attorneys' fees) arising out of or relating to your violation of these Terms of Use or your use of the Website.</p>

          <strong style={{ display: 'block' }}>Revisions and Errata</strong>
          <p>The materials appearing on Datagenetx's web site could include technical, typographical, or photographic errors. Datagenetx does not warrant that any of the materials on its web site are accurate, complete, or current. Datagenetx may make changes to the materials contained on its web site at any time without notice.</p>

          <strong style={{ display: 'block' }}>Links</strong>
          <p>Datagenetx has not reviewed all of the sites linked to its Internet web site and is not responsible for the contents of any such linked site. The inclusion of any link does not imply endorsement by Datagenetx of the site. Use of any such linked web site is at the user's own risk.</p>

          <strong style={{ display: 'block' }}>Site Terms of Use Modifications</strong>
          <p>Datagenetx may revise these terms of use for its web site at any time without notice. By using this web site you are agreeing to be bound by the then current version of these Terms and Conditions of Use.</p>

          <strong style={{ display: 'block' }}>Governing Law</strong>
          <p>Any claim relating to Datagenetx web site shall be governed by the laws of the State of Oklahoma without regard to its conflict of law provisions.</p>

          <strong style={{ display: 'block' }}>Children Under the Age of 13</strong>
          <p>The safety and privacy of children is very important to us. This Web Site is not intended for children under the age of 13. Datagenetx will not knowingly register or otherwise collect Personal Information from persons who identify themselves as being under the age of 13 during the registration process, without the prior consent of such child's parent or guardian. By accepting our terms of service, you are affirming that you are 13 years of age or older.</p>

          <strong style={{ display: 'block' }}>User Information</strong>
          <p>When you register for the Datagenetx service, you will be asked to provide certain information including, but not limited to, first and last name, a valid email address, city, state, and other identifying information. You understand and agree that Datagenetx may disclose to third parties, aggregate and certain personally identifiable information based on your use of the Datagenetx service. We are not responsible for any data collection and practices of non-affiliated third-parties that are linked to or from our Website.</p>

          <strong style={{ display: 'block' }}>Agreement to be Contacted</strong>
          <p>You agree to be contacted by Datagenetx or on our behalf or by any other party to whom you may be referred by mail, email, telephone calls, text messages, and other platforms for marketing and non-marketing purposes associated with the business of the Services. You also specifically agree that you have provided express consent to receive autodialed and prerecorded non-marketing calls and text messages from us or on our behalf at the telephone number(s) that you provide.</p>
          <p>You confirm that all of your contact information is correct. You also agree that you are the subscriber for any telephone number(s) provided and the authorized user for the email address(es) provided.</p>

          <strong style={{ display: 'block' }}>Your Representations about the Data You Provide to Us</strong>
          <p>You confirm that you are authorized to provide us with any data you submit to Datagenetx. You represent that the data you provide is accurate to the best of your knowledge, understand that we may terminate your use of our services without notice for providing us with inaccurate or unauthorized information.</p>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowTerms(false)}>Close</Button>
        </Modal.Footer>
      </Modal>

      <Modal show={showPartner} onHide={() => setShowPartner(false)} centered size="lg">
        <Modal.Header closeButton>
          <Modal.Title>Partner / Affiliates</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p>Interested in partnering with Datagenetx? We work with a network of affiliates and marketing partners.</p>
          <p>For partnership inquiries, please reach out to us at <a href="mailto:info@datagenetx.com">info@datagenetx.com</a> or call <a href="tel:4054559053">(405) 455-9053</a>.</p>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowPartner(false)}>Close</Button>
        </Modal.Footer>
      </Modal>
    </Container>
  );
}

export default Footer;
